import React from 'react';

const ProgressBar = ({ currentStep }) => {
  const steps = [
    { label: "Phone" },
    { label: "Partner Info" },
    { label: "Business Info" },
    { label: "Security" }
  ];

  return (
    <div className="flex flex-col items-center w-full mb-8">
      <div className="text-center space-y-1 mb-6">
        <h2 className="text-white font-semibold text-2xl md:text-3xl">Register Now</h2>
        <div className="h-1 w-12 bg-white/20 rounded-full mx-auto"></div>
      </div>

      <div className='w-full md:w-[90%] mx-auto mt-2 flex justify-between items-center text-sm relative'>
        {/* Progress Line */}
        <div className='w-full h-[3px] bg-white/10 absolute top-1.5 rounded-full'></div>
        <div
          className='h-[3px] overflow-hidden bg-white absolute top-1.5 transition-all duration-500 ease-out rounded-full'
          style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
        ></div>

        {/* Progress Points */}
        {steps.map((step, index) => (
          <div
            key={index}
            className='flex flex-col items-center relative z-10'
          >
            <div
              className={`w-3 h-3 rounded-full border-2 transition-all duration-300 ${currentStep >= index
                ? 'bg-white border-white scale-125'
                : 'bg-[#077b7b] border-white/30'
                }`}
            ></div>
            <span className={`mt-3 text-[10px] font-bold tracking-wider uppercase transition-colors duration-300 ${currentStep >= index ? 'text-white' : 'text-white/30'
              }`}>{step.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;